// Module
var code = `<div appHeaderBar>
    <header-bar-title>Card Details</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text" tid="cardDetailsHeader">Card Details</h1>
        </div>
        <div class="HOA-container__content">
            <app-credit-card-checkout-edit
                    [paymentMethodId]="paymentMethodId"
                    (return)="onReturn()"
                    (goto)="onGoTo()">
            </app-credit-card-checkout-edit>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;